export default "__VITE_ASSET__74da31eb__"